import { ApiService } from '../../app-lite/api/api.service';
import { TableService }  from '../../app-lite/table/table.service';

import ProductHtml  from '../../app-lite/products/product.html';
import ProductsHtml from '../../app-lite/products/products.html';

export function ProductsStates (
  $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller : 'ProductsCtrl',
    name       : 'app.products',
    templateUrl: ProductsHtml,
    url        : '/products',
    resolve    : {
      products: ( tableApi : TableService, workshopAPI : ApiService ) : ng.IPromise<any> => {
        const cache = tableApi.getCacheForTable('products');

        return workshopAPI.stream('/filters', [
          cache.filtering.value ? cache.filtering.value : '*',
          'products',
          0,
          cache.paging.pageSize   || 10,
          cache.sorting.field     || 'item_code',
          cache.sorting.direction || 'asc',
          cache.filtering.archived_only ? cache.filtering.archived_only : false
        ]);
      }
      }
  })
  .state({
    controller: 'ProductCtrl',
    name      : 'app.product',
    params    : {
      id: { squash: true, value: null }
    },
    templateUrl: ProductHtml,
    url        : '/product/:id',
    resolve    : {
      invoices: ( $stateParams : ng.ui.IStateParamsService, tableApi : TableService, workshopAPI : ApiService ) : ng.IPromise<any> | Array<any> => {
        const cache = tableApi.getCacheForTable('productInvoices');

        return $stateParams.id ? workshopAPI.get('/products/invoice_list', [
          $stateParams.id,
          0,
          cache.paging.pageSize   || 5,
          cache.sorting.field     || 'post_date',
          cache.sorting.direction || 'desc'
        ]) : [];
      },
      log: ( $stateParams : ng.ui.IStateParamsService, tableApi : TableService, workshopAPI : ApiService ) : ng.IPromise<any> | Array<any> => {
        const cache = tableApi.getCacheForTable('productStockTake');

        return $stateParams.id ? workshopAPI.get('/stock_take_logs', [
          $stateParams.id,
          0,
          cache.paging.pageSize || 5
        ]) : [];
      },
      orders: ( $stateParams : ng.ui.IStateParamsService, tableApi : TableService, workshopAPI : ApiService ) : ng.IPromise<any> | Array<any> => {
        const cache = tableApi.getCacheForTable('productStockOrders');

        return $stateParams.id ? workshopAPI.get('/products/purchase_order_list', [
          $stateParams.id,
          0,
          cache.paging.pageSize   || 5,
          cache.sorting.field     || 'order_date',
          cache.sorting.direction || 'desc'
        ]) : [];
      },
      product: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | string=> $stateParams.id
        ? workshopAPI.get('/product', $stateParams.id)
        : '',
      product_categories: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/product_categories'),
      reserved          : ( $stateParams : ng.ui.IStateParamsService, tableApi : TableService, workshopAPI : ApiService ) : ng.IPromise<any> | Array<any> => {
        const cache = tableApi.getCacheForTable('productReserved');

        return $stateParams.id ? workshopAPI.get('/products/reserved_invoice_list', [
          $stateParams.id,
          0,
          cache.paging.pageSize   || 5,
          cache.sorting.field     || 'post_date',
          cache.sorting.direction || 'desc'
        ]) : [];
      },
      serialNumbers: ( $stateParams : ng.ui.IStateParamsService, tableApi : TableService, workshopAPI : ApiService ) : ng.IPromise<any> | Array<any> => {
        const cache = tableApi.getCacheForTable('productSerialNumbers');

        return $stateParams.id ? workshopAPI.get('/products/serial_number_list', [
          $stateParams.id,
          0,
          cache.paging.pageSize   || 5,
          cache.sorting.field     || 'serial_number',
          cache.sorting.direction || 'asc'
        ]) : [];
      },
      vendorInvoices: ( $stateParams : ng.ui.IStateParamsService, tableApi : TableService, workshopAPI : ApiService ) : ng.IPromise<any> | Array<any> => {
        const cache = tableApi.getCacheForTable('productHistory');

        return $stateParams.id ? workshopAPI.get('/products/vendor_invoice_list', [
          $stateParams.id,
          0,
          cache.paging.pageSize   || 5,
          cache.sorting.field     || 'post_date',
          cache.sorting.direction || 'asc'
        ]) : [];
      }
    }
  });
};